module.exports = __webpack_public_path__ + "static/avatar-gen-fb8152eab362f7a956b6df4baaa49901.gif";